import { InputField } from './form-controls';
import { SectionShell, FieldGrid } from './section-shell';

/**
 * Contract term dates. Effective + expiry are required `YYYY-MM-DD` strings
 * (native date inputs, no UTC shift); the schema enforces expiry ≥ effective.
 * Defaults are today and today + 1 year − 1 day (legacy).
 */
export function DatesSection() {
  return (
    <SectionShell title="Contract term" description="When does this contract start and end?">
      <FieldGrid>
        <InputField name="contract_effective_date" label="Effective date" type="date" required />
        <InputField name="contract_expiry_date" label="Expiry date" type="date" required />
      </FieldGrid>
    </SectionShell>
  );
}
